/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { appId } from "../Helpers/Config";
import cookie from "react-cookies";
import Slider from "react-slick";
import {reactLocalStorage} from 'reactjs-localstorage';
var dateFormat = require("dateformat");


import validator from "validator";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { showCustomAlert } from "../Helpers/SettingHelper";
import {
  GET_LOYLATITY_CUSTOMER_DETAIL,
  GET_UPDATECUSTOMERPROFILE,
  GET_ACTIVITYCOUNT,
} from "../../actions";

import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

/* import modules */
import Header from "../Layout/CustomerHeader";
import Footer from "../Layout/Footer";
import Form from "./Form";

var qs = require("qs");

class Myaccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        firstname: "",
        lastname: "",
        nickname: "",
        email: "",
        mobile: "",
        postal: "",
        unitnumber2: "",
        unitnumber1: "",
        company: "",
        birthdate: "",
        fbid: "",
        image_source: "",
        photo: "",
        gender: "",
      },
      status: "OK",
      date1: "",
      defaultDispaly: "",
      order_all: 0,
      overall_orders: 0,

      activityPoints: {
        reward_ponits: "",
        reward_ponits_monthly: "",
        order_all: "",
        promotion: "",
      },
      ordercount: 0,
    };

    if (reactLocalStorage.get("LoyaltyUserId") == "" || reactLocalStorage.get("LoyaltyUserId") == undefined) {
      props.history.push("/");
    }
  }

  componentDidMount() {
    var params = "&status=A&refrence=" + reactLocalStorage.get("LoyaltyUserId");
    $("#dvLoading").fadeOut(4000);
    this.props.getCustomerDetailLoyalty(params);
    this.getActivityCountsNew();
  
    setTimeout(function () {
      if ($(".mCustomScrollbar").length > 0) {
        $(".mCustomScrollbar").mCustomScrollbar();
      }
    }, 600);
  }

  getActivityCountsNew() {
    const inputKeys = ["order_all", "overall_orders"];
    const login_type = "Customer";
    this.props.getActivityCount(JSON.stringify(inputKeys), login_type);
  }

  fieldChange = (field, value) => {
    this.setState(update(this.state, { fields: { [field]: { $set: value } } }));
  };

  /* To Submit the personal informartion form */
  handleFormSubmit = () => {
    const formPayload = this.state.fields;

    var postObject = {
      type: "web",
      customer_first_name: formPayload.firstname,
      customer_last_name: formPayload.lastname,
      customer_nick_name: formPayload.nickname,
      customer_phone: formPayload.mobile,
      customer_email: formPayload.email,
      customer_birthdate: cookie
        .load("birthdate")
        .replace("/", "-")
        .replace("/", "-"),
      customer_postal_code: formPayload.postal,
      customer_address_name2: formPayload.address1,
      customer_company_name: formPayload.company,
      customer_gender: formPayload.gender.value,
      customer_address_line1: formPayload.unitnumber1,
      customer_address_line2: formPayload.unitnumber2,
      customer_id: reactLocalStorage.get("LoyaltyUserId"),
    };
    $(".myaccount_update").append('<b class="gloading_img"></b>');
    this.props.getUpdateCustomerProfile(qs.stringify(postObject));
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.updatecustomerprofile !== this.props.updatecustomerprofile) {
      const { updatecustomerprofile } = nextProps;
      if (updatecustomerprofile[0].status === "ok") {
        $(".myaccount_update .gloading_img").remove();

        reactLocalStorage.set("UserFname", updatecustomerprofile[0].result_set.customer_first_name);
        reactLocalStorage.set("UserLname",updatecustomerprofile[0].result_set.customer_last_name);
        reactLocalStorage.set("UserMobile", updatecustomerprofile[0].result_set.customer_phone);
        reactLocalStorage.set("UserEmail", updatecustomerprofile[0].result_set.customer_email);
        reactLocalStorage.set("UserDefaultAddress", updatecustomerprofile[0].result_set.customer_address_name);
        reactLocalStorage.set("UserDefaultUnitOne", updatecustomerprofile[0].result_set.customer_address_line1);
        reactLocalStorage.set("UserDefaultUnitTwo", updatecustomerprofile[0].result_set.customer_address_line2);
        reactLocalStorage.set("UserDefaultPostalCode", updatecustomerprofile[0].result_set.customer_postal_code);

        showCustomAlert("success", "Profile has been updated successfully.");
      } else {
         $(".myaccount_update .gloading_img").remove();
        if (updatecustomerprofile[0].form_error) {
          showCustomAlert("error", updatecustomerprofile[0].form_error);
        } else {
          showCustomAlert("error", updatecustomerprofile[0].message);
        }
      }
    }

    if (nextProps.loyaltycustomerdetail !== this.props.loyaltycustomerdetail) {
      //const {customerdetail} = nextProps;
      if (nextProps.loyaltycustomerdetail[0].status === "ok") {
        $("#dvLoading").fadeOut(4000);
        if (
          nextProps.loyaltycustomerdetail[0].result_set.customer_birthdate == null ||
          nextProps.loyaltycustomerdetail[0].result_set.customer_birthdate ==
            "0000-00-00"
        ) {
          var birthdate = "";
        } else {
          var birthdate =
            nextProps.loyaltycustomerdetail[0].result_set.customer_birthdate;
          var birthyear = birthdate.substring(0, 4);
          var birthmonth = birthdate.substring(5, 7);
          var birthdatev = birthdate.substring(8, 10);
          var birthdateTemp = birthdatev + "/" + birthmonth + "/" + birthyear;
          cookie.save("birthdate", birthdateTemp, { path: "/" });
        }

        this.setState({
          fields: {
            firstname:
              nextProps.loyaltycustomerdetail[0].result_set.customer_first_name !==
              null
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_first_name
                : "",
            birthdate: birthdate,
            lastname:
              nextProps.loyaltycustomerdetail[0].result_set.customer_last_name !== null
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_last_name
                : "",
            nickname:
              nextProps.loyaltycustomerdetail[0].result_set.customer_nick_name !== null
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_nick_name
                : "",
            email:
              nextProps.loyaltycustomerdetail[0].result_set.customer_email !== null
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_email
                : "",
            mobile:
              nextProps.loyaltycustomerdetail[0].result_set.customer_phone !== null
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_phone
                : "",

            photo:
              nextProps.loyaltycustomerdetail[0].result_set.customer_photo !== null &&
              nextProps.loyaltycustomerdetail[0].result_set.customer_photo !== ""
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_photo.indexOf(
                    "http"
                  ) > 0
                  ? nextProps.loyaltycustomerdetail[0].result_set.customer_photo
                  : nextProps.loyaltycustomerdetail[0].common.image_source +
                    nextProps.loyaltycustomerdetail[0].result_set.customer_photo
                : "",
            postal:
              nextProps.loyaltycustomerdetail[0].result_set.customer_postal_code !==
              null
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_postal_code
                : "",
            unitnumber2:
              nextProps.loyaltycustomerdetail[0].result_set.customer_address_line2 !==
              null
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_address_line2
                : "",
            unitnumber1:
              nextProps.loyaltycustomerdetail[0].result_set.customer_address_line1 !==
              null
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_address_line1
                : "",
            address:
              nextProps.loyaltycustomerdetail[0].result_set.customer_address_name !==
              null
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_address_name
                : "",
            address1:
              nextProps.loyaltycustomerdetail[0].result_set.customer_address_name2 !==
              null
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_address_name2
                : "",
            company:
              nextProps.loyaltycustomerdetail[0].result_set.customer_company_name !==
              null
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_company_name
                : "",
            fbid: nextProps.loyaltycustomerdetail[0].result_set.customer_fb_id,
            image_source: nextProps.loyaltycustomerdetail[0].common.image_source,
            juicedid:
              nextProps.loyaltycustomerdetail[0].result_set.customer_unique_id !== null
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_unique_id
                : "",
            joinedOn:
              nextProps.loyaltycustomerdetail[0].result_set.customer_created_on !==
              null
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_created_on
                : "",
            gender:
              nextProps.loyaltycustomerdetail[0].result_set.customer_gender !== null &&
              nextProps.loyaltycustomerdetail[0].result_set.customer_gender !== ""
                ? nextProps.loyaltycustomerdetail[0].result_set.customer_gender
                : "M",
          },
          status: nextProps.loyaltycustomerdetail[0].status,
        });

        var vDefaultAddr = "";
        var list = document.getElementsByClassName("form-group-input");
        var n;
        for (n = 0; n < list.length; ++n) {
          if (list[n].getElementsByTagName("input")[0].value !== "") {
            list[n].classList.remove("is-empty");
          } else {
            list[n].classList.add("is-empty");
          }
        }
      }
    }

    /*activity count -start */
    if (Object.keys(nextProps.activitycount).length > 0) {
      if (nextProps.activitycount !== this.props.activitycount) {
        if (
          nextProps.activitycount[0].status &&
          nextProps.activitycount[0].result_set
        ) {
          this.setState({
            order_all: nextProps.activitycount[0].result_set.order_all,
            overall_orders:
              nextProps.activitycount[0].result_set.overall_orders,
          });
        }
      }
    } else {
      this.setState({ order_all: 0, overall_orders: 0 });
    }
  }
  sateValChange = (field, value) => {};



  showMembershipDesc(memberShpType) {
      if(memberShpType === 'Gold') {
        return(<p>12% Cashback for every online order.</p>);
      } else if(memberShpType === 'Silver') {
        return(<p>8% Cashback for every online order.</p>);
      } else {
        return(<p>5% Cashback for every online order.</p>);   
      }
  }


  render() {

    var currenturl = window.location.href;
    var myaccount = "myaccount";
    var myorders = "myorders";
    var rewards = "rewards";
    var mypromotions = "mypromotions";
    var myvouchers = "myvouchers";


    return (
      <div className="myacc-main-div">
        <Header sateValChange={this.sateValChange}/>
        <div className="common-inner-blckdiv">
          <div className="common-inner-banner">
            <h3>My Account</h3>
            <p>
              My Account Dashboard allows you to view your recent activities, update account information.
            </p>
          </div>
        </div>
        <div className="innersection_wrap myadmin_wrap">
          <div className="mainacc_menusec">
            {/* container div - start */}
            <div className="container">

             <div className="memb-foot">
             <div className="memb-payment">
                <div className="memb-payment-row">
                   <div className="memb-payment-col">
                   <div className="memb-payment-col-radio">
                         <div className="col-md-12">
                            <div className="col-md-2 memb-first">
                 
                            </div>
                            <div className="col-md-4 memb-bord">
                            <div className="memb-bord-inner">
                             </div>
                            </div>
                            <div className="col-md-6 memb-second">
                            </div>
                         </div>
                         </div>
                     </div>
                  </div>
               </div>
            </div>         

              <div className="mainacc_menucontent">
                <div className="main_tabsec">
                  <div className="order-tab-section">
                    <div className="mainacc_mobrow">
                      <div className="tab_sec main_tabsec_inner">
                        <div className="myacc_filter">
                          <div className="tab_sec filter_tabsec">
                            <Form
                              {...this.props}
                              fields={this.state.fields}
                              activityPoints={this.state.activityPoints}
                              onChange={this.fieldChange}
                              onValid={this.handleFormSubmit}
                              onInvalid={() => console.log("Form invalid!")}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* container div - end */}
          </div>
        </div>

        <div id="dvLoading"></div>

        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loyaltycustomerdetail: state.loyaltycustomerdetail,
    updatecustomerprofile: state.updatecustomerprofile,
    activitycount: state.activitycount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerDetailLoyalty: (params) => {
      dispatch({ type: GET_LOYLATITY_CUSTOMER_DETAIL, params });
    }, 
    getUpdateCustomerProfile: (formPayload) => {
      dispatch({ type: GET_UPDATECUSTOMERPROFILE, formPayload });
    },
    getActivityCount: (getObject, login_type) => {
      dispatch({ type: GET_ACTIVITYCOUNT, getObject, login_type});
    },
  };
};

Myaccount.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Myaccount)
);
